import { styled } from '@mui/material'
import Button from 'components/Button'
import Input from 'components/Input'

export const SearchButton = styled(Button)(() => ({
  width: '42px',
  height: '42px',
  padding: 0,
  minWidth: 0,
  flexShrink: 0,
  borderRadius: '100%',
}))

export const SearchInput = styled(Input)(({ theme }) => ({
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1.5),
  },
}))

export const SearchInputContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
}))
